export const allCountries = [
  { countryName: "Afghanistan", countryCode: "AF", dialCode: "+93" },
  { countryName: "Albania", countryCode: "AL", dialCode: "+355" },
  { countryName: "Algeria", countryCode: "DZ", dialCode: "+213" },
  { countryName: "Andorra", countryCode: "AD", dialCode: "+376" },
  { countryName: "Angola", countryCode: "AO", dialCode: "+244" },
  { countryName: "Argentina", countryCode: "AR", dialCode: "+54" },
  { countryName: "Armenia", countryCode: "AM", dialCode: "+374" },
  { countryName: "Australia", countryCode: "AU", dialCode: "+61" },
  { countryName: "Austria", countryCode: "AT", dialCode: "+43" },
  { countryName: "Azerbaijan", countryCode: "AZ", dialCode: "+994" },
  { countryName: "Bahrain", countryCode: "BH", dialCode: "+973" },
  { countryName: "Bangladesh", countryCode: "BD", dialCode: "+880" },
  { countryName: "Belarus", countryCode: "BY", dialCode: "+375" },
  { countryName: "Belgium", countryCode: "BE", dialCode: "+32" },
  { countryName: "Bhutan", countryCode: "BT", dialCode: "+975" },
  { countryName: "Bolivia", countryCode: "BO", dialCode: "+591" },
  {
    countryName: "Bosnia and Herzegovina",
    countryCode: "BA",
    dialCode: "+387",
  },
  { countryName: "Brazil", countryCode: "BR", dialCode: "+55" },
  { countryName: "Brunei", countryCode: "BN", dialCode: "+673" },
  { countryName: "Bulgaria", countryCode: "BG", dialCode: "+359" },
  { countryName: "Cambodia", countryCode: "KH", dialCode: "+855" },
  { countryName: "Cameroon", countryCode: "CM", dialCode: "+237" },
  { countryName: "Canada", countryCode: "CA", dialCode: "+1" },
  { countryName: "Chile", countryCode: "CL", dialCode: "+56" },
  { countryName: "China", countryCode: "CN", dialCode: "+86" },
  { countryName: "Colombia", countryCode: "CO", dialCode: "+57" },
  { countryName: "Costa Rica", countryCode: "CR", dialCode: "+506" },
  { countryName: "Croatia", countryCode: "HR", dialCode: "+385" },
  { countryName: "Cuba", countryCode: "CU", dialCode: "+53" },
  { countryName: "Cyprus", countryCode: "CY", dialCode: "+357" },
  { countryName: "Czech Republic", countryCode: "CZ", dialCode: "+420" },
  { countryName: "Denmark", countryCode: "DK", dialCode: "+45" },
  { countryName: "Egypt", countryCode: "EG", dialCode: "+20" },
  { countryName: "Estonia", countryCode: "EE", dialCode: "+372" },
  { countryName: "Finland", countryCode: "FI", dialCode: "+358" },
  { countryName: "France", countryCode: "FR", dialCode: "+33" },
  { countryName: "Germany", countryCode: "DE", dialCode: "+49" },
  { countryName: "Ghana", countryCode: "GH", dialCode: "+233" },
  { countryName: "Greece", countryCode: "GR", dialCode: "+30" },
  { countryName: "Hong Kong", countryCode: "HK", dialCode: "+852" },
  { countryName: "Hungary", countryCode: "HU", dialCode: "+36" },
  { countryName: "Iceland", countryCode: "IS", dialCode: "+354" },
  { countryName: "India", countryCode: "IN", dialCode: "+91" },
  { countryName: "Indonesia", countryCode: "ID", dialCode: "+62" },
  { countryName: "Iran", countryCode: "IR", dialCode: "+98" },
  { countryName: "Iraq", countryCode: "IQ", dialCode: "+964" },
  { countryName: "Ireland", countryCode: "IE", dialCode: "+353" },
  { countryName: "Israel", countryCode: "IL", dialCode: "+972" },
  { countryName: "Italy", countryCode: "IT", dialCode: "+39" },
  { countryName: "Japan", countryCode: "JP", dialCode: "+81" },
  { countryName: "Jordan", countryCode: "JO", dialCode: "+962" },
  { countryName: "Kenya", countryCode: "KE", dialCode: "+254" },
  { countryName: "Kuwait", countryCode: "KW", dialCode: "+965" },
  { countryName: "Laos", countryCode: "LA", dialCode: "+856" },
  { countryName: "Lebanon", countryCode: "LB", dialCode: "+961" },
  { countryName: "Luxembourg", countryCode: "LU", dialCode: "+352" },
  { countryName: "Malaysia", countryCode: "MY", dialCode: "+60" },
  { countryName: "Maldives", countryCode: "MV", dialCode: "+960" },
  { countryName: "Mexico", countryCode: "MX", dialCode: "+52" },
  { countryName: "Mongolia", countryCode: "MN", dialCode: "+976" },
  { countryName: "Morocco", countryCode: "MA", dialCode: "+212" },
  { countryName: "Myanmar", countryCode: "MM", dialCode: "+95" },
  { countryName: "Nepal", countryCode: "NP", dialCode: "+977" },
  { countryName: "Netherlands", countryCode: "NL", dialCode: "+31" },
  { countryName: "New Zealand", countryCode: "NZ", dialCode: "+64" },
  { countryName: "Nigeria", countryCode: "NG", dialCode: "+234" },
  { countryName: "Norway", countryCode: "NO", dialCode: "+47" },
  { countryName: "Oman", countryCode: "OM", dialCode: "+968" },
  { countryName: "Pakistan", countryCode: "PK", dialCode: "+92" },
  { countryName: "Philippines", countryCode: "PH", dialCode: "+63" },
  { countryName: "Poland", countryCode: "PL", dialCode: "+48" },
  { countryName: "Portugal", countryCode: "PT", dialCode: "+351" },
  { countryName: "Qatar", countryCode: "QA", dialCode: "+974" },
  { countryName: "Russia", countryCode: "RU", dialCode: "+7" },
  { countryName: "Saudi Arabia", countryCode: "SA", dialCode: "+966" },
  { countryName: "Singapore", countryCode: "SG", dialCode: "+65" },
  { countryName: "South Africa", countryCode: "ZA", dialCode: "+27" },
  { countryName: "South Korea", countryCode: "KR", dialCode: "+82" },
  { countryName: "Spain", countryCode: "ES", dialCode: "+34" },
  { countryName: "Sri Lanka", countryCode: "LK", dialCode: "+94" },
  { countryName: "Sweden", countryCode: "SE", dialCode: "+46" },
  { countryName: "Switzerland", countryCode: "CH", dialCode: "+41" },
  { countryName: "Thailand", countryCode: "TH", dialCode: "+66" },
  { countryName: "Turkey", countryCode: "TR", dialCode: "+90" },
  { countryName: "United Arab Emirates", countryCode: "AE", dialCode: "+971" },
  { countryName: "United Kingdom", countryCode: "GB", dialCode: "+44" },
  { countryName: "United States", countryCode: "US", dialCode: "+1" },
  { countryName: "Vietnam", countryCode: "VN", dialCode: "+84" },
];


 export const countries = [
    {
      countryName: "Afghanistan",
      countryCode: "AF",
      dialCode: "+93",
      phoneLength: 9,
    },
    {
      countryName: "Albania",
      countryCode: "AL",
      dialCode: "+355",
      phoneLength: 9,
    },
    {
      countryName: "Algeria",
      countryCode: "DZ",
      dialCode: "+213",
      phoneLength: 9,
    },
    {
      countryName: "Australia",
      countryCode: "AU",
      dialCode: "+61",
      phoneLength: 9,
    },
    {
      countryName: "Bangladesh",
      countryCode: "BD",
      dialCode: "+880",
      phoneLength: 10,
    },
    {
      countryName: "Canada",
      countryCode: "CA",
      dialCode: "+1",
      phoneLength: 10,
    },
    {
      countryName: "China",
      countryCode: "CN",
      dialCode: "+86",
      phoneLength: 11,
    },
    {
      countryName: "France",
      countryCode: "FR",
      dialCode: "+33",
      phoneLength: 9,
    },
    {
      countryName: "Germany",
      countryCode: "DE",
      dialCode: "+49",
      phoneLength: 10,
    },
    {
      countryName: "India",
      countryCode: "IN",
      dialCode: "+91",
      phoneLength: 10,
    },
    {
      countryName: "Indonesia",
      countryCode: "ID",
      dialCode: "+62",
      phoneLength: 10,
    },
    {
      countryName: "Japan",
      countryCode: "JP",
      dialCode: "+81",
      phoneLength: 10,
    },
    {
      countryName: "Nepal",
      countryCode: "NP",
      dialCode: "+977",
      phoneLength: 10,
    },
    {
      countryName: "Pakistan",
      countryCode: "PK",
      dialCode: "+92",
      phoneLength: 10,
    },
    {
      countryName: "Saudi Arabia",
      countryCode: "SA",
      dialCode: "+966",
      phoneLength: 9,
    },
    {
      countryName: "Singapore",
      countryCode: "SG",
      dialCode: "+65",
      phoneLength: 8,
    },
    {
      countryName: "Sri Lanka",
      countryCode: "LK",
      dialCode: "+94",
      phoneLength: 9,
    },
    {
      countryName: "United Arab Emirates",
      countryCode: "AE",
      dialCode: "+971",
      phoneLength: 9,
    },
    {
      countryName: "United Kingdom",
      countryCode: "GB",
      dialCode: "+44",
      phoneLength: 10,
    },
    {
      countryName: "United States",
      countryCode: "US",
      dialCode: "+1",
      phoneLength: 10,
    },
  ];